import { Button, Container, Grid, Tab, Tabs } from "@mui/material";
import React, { FunctionComponent } from "react"; 
import { CustomBreadcrumbsMolecule, CustomBreadcrumbsMoleculeProps } from "../../molecules/CustomBreadcrumbsMolecule";
import { PageTitle, PageTitleProps } from "../../molecules/PageTitle";
import { FiFilter } from "react-icons/fi";


type PageHeaderRootProps = {
  children: React.ReactNode
}

type PageHeaderTitleProps = PageTitleProps & {
  action?: React.ReactNode
}

type PageHeaderTabsProps = {
  tabs: string[]
  action?: React.ReactNode
}

type PageHeaderFilterProps = {
  children?: React.ReactNode
  onOpenFilter: () => void
}

const PageHeaderBreadcrumb: FunctionComponent<CustomBreadcrumbsMoleculeProps> = ({breadcrumbs}) => {
  return (
    <Grid item mb="20px">
      <CustomBreadcrumbsMolecule breadcrumbs={breadcrumbs} />
    </Grid>
  );
};

const PageHeaderTitle: FunctionComponent<PageHeaderTitleProps> = ({title, subtitle, action}) => {
  return (
    <Grid
      alignItems="center"
      container
      direction="row"
      item
      justifyContent="space-between"
    >
      <PageTitle title={title} subtitle={subtitle} />
      {action ? action : null}
    </Grid>
  );
};

const PageHeaderTabs: FunctionComponent<PageHeaderTabsProps> = ({tabs, action}) => {
  return (
    <Grid
      alignItems="center"
      container
      direction="row"
      item
      justifyContent="space-between"
    >
      <Tabs>
        {tabs ? tabs.map(tab => (
          <Tab key={tab} label={tab} />
        )) : null}
      </Tabs>
      {action ? action : null}
    </Grid>
  );
};

const PageHeaderFilter: FunctionComponent<PageHeaderFilterProps> = ({children, onOpenFilter}) => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      mt='20px'
    >
      <Button
        color="secondary"
        onClick={onOpenFilter}
        startIcon={<FiFilter />}
        variant="outlined"
      >
      Filters
      </Button>
      {children}
    </Grid>
  );
};

const PageHeaderRoot: FunctionComponent<PageHeaderRootProps> = ({children}) => {
  return (
    <Container>
      <Grid container direction="column" pt="24px">
        {children}
      </Grid>
    </Container>
  );
};

export const PageHeader = {
  Root: PageHeaderRoot,
  Breadcrumb: PageHeaderBreadcrumb,
  Title: PageHeaderTitle,
  Tabs: PageHeaderTabs,
  Filter: PageHeaderFilter
};